define('../app/fukit/view/block/labeled.components.container.view',['require','exports','module','uikit/uikit','./label.component.view'],function(require, exports, module) {
  //prettier-ignore
  var UIKit             = require('uikit/uikit'),
      LabelComponentView = require('./label.component.view');

  var LabeledComponentsContainerView = UIKit.ComponentsContainerView.extend({
    className: 'ui segment tertiary form',
    childView: LabelComponentView
  });

  module.exports = LabeledComponentsContainerView;
})
;
